import { Component, OnInit } from '@angular/core';
import { ValidateJWTError, ValidateJWTRequest } from '../store/auth.actions';
import { select, Store } from '@ngrx/store';
import { selectAuthClaims } from '../store/auth.store';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthState } from '../store/auth.state';
import { isArray, isObject } from 'lodash-es';
import { ConfigManagerService } from '../../shared/services/config-manager.service';
import { AuthErrorCode } from '../../../../common/models/auth-api.interface';
import { BaseAbstractComponent } from '../../shared/base/base-abstract.component';

@Component({
    standalone: false,
    selector: 'q-auth-page',
    templateUrl: `./auth-page.component.html`,
    styles: ['']
})
export class AuthPageComponent extends BaseAbstractComponent implements OnInit {
    private redirect: string = '/';

    constructor(
        private store: Store<AuthState>,
        private route: ActivatedRoute,
        private router: Router,
        private configManagerService: ConfigManagerService
    ) {
        super();

        this.route.queryParams
            .pipe(takeUntil(this.$destroy))
            .subscribe(
                (params) =>
                    (this.redirect = params['qssAppReturnUrl']
                        ? params['qssAppReturnUrl']
                        : this.redirect)
            );
    }

    ngOnInit() {
        this.store.dispatch(new ValidateJWTRequest());
        this.store
            .pipe(
                select(selectAuthClaims),
                filter(
                    (claims) =>
                        isObject(claims) && isArray(claims.enabled_sso_apps)
                )
            )
            .pipe(takeUntil(this.$destroy))
            .subscribe((claims) => {
                if (
                    claims.enabled_sso_apps.indexOf(
                        this.configManagerService.ssoConfig.appKey
                    ) < 0
                ) {
                    this.store.dispatch(
                        new ValidateJWTError(AuthErrorCode.UNAUTHORIZED)
                    );
                } else {
                    /* replaceUrl => When true, navigates while replacing the current state in history. */
                    /* Solves the problem of multiple back clicks to reach intended landing page,
                    by not adding "/events" to browser history and replacing it with the child navigation
                    url, i.e. "/events/list". */
                    this.router.navigate([this.redirect], {
                        replaceUrl: true
                    });
                }
            });
    }

    preOnDestroy(): any {}
}
